package com.mrpowergamerbr.puppydough.webrune

data class KnownGameVersion(val version: String, val platform: String, val compatibility: GameCompatibility = GameCompatibility.COMPATIBLE) {
    val displayName get() = "DELTARUNE $version ($platform)"
}

enum class GameCompatibility {
    COMPATIBLE,
    UNKNOWN,
    INCOMPATIBLE,
}

fun getGameCompatibility(hash: String) = KNOWN_DELTARUNE_VERSIONS[hash]?.compatibility ?: GameCompatibility.UNKNOWN

// MD5 of the data.win (or game.ios on macOS)
val KNOWN_DELTARUNE_VERSIONS = mapOf(
    "7ad299a8b33fa449e20edfe0fededdb2" to KnownGameVersion("Chapter 1 & 2 DEMO", "Windows, itch.io"),
    "24b635b2898ebc23dec92677d2725ed2" to KnownGameVersion("Chapter 1 & 2 DEMO", "macOS, itch.io"),
    "5d3e158dbe6888fbf24471019fbde3c9" to KnownGameVersion("Chapter 3 & 4", "Windows, Steam"),
    "83a5a14f9b92a20f21fb9ec6c8528469" to KnownGameVersion("Chapter 5", "Windows, Steam"),
)
